export default "__VITE_ASSET__0p2hBpqx__"